import React from "react";

const UnconfirmedStudentDetails = ({ notYetConfirmedDetails, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate({
      notYetConfirmedDetails: {
        ...notYetConfirmedDetails,
        [field]: value,
      },
    });
  };

  return (
    <div className="space-y-4 border border-blue-200 bg-blue-50 p-4 rounded-md">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Approximate number of students
        </label>
        <input
          type="number"
          className="w-full border rounded-md px-3 py-2"
          value={notYetConfirmedDetails?.approxNumStudents || ""}
          onChange={(e) => handleChange("approxNumStudents", e.target.value)}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Year levels involved
        </label>
        <input
          type="text"
          className="w-full border rounded-md px-3 py-2"
          placeholder="e.g. Prep, Year 7, Year 10"
          value={notYetConfirmedDetails?.yearLevels || ""}
          onChange={(e) => handleChange("yearLevels", e.target.value)}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Description of students
        </label>
        <textarea
          rows={3}
          className="w-full border rounded-md px-3 py-2"
          placeholder="Provide any relevant detail..."
          value={notYetConfirmedDetails?.description || ""}
          onChange={(e) => handleChange("description", e.target.value)}
        />
      </div>
    </div>
  );
};

export default UnconfirmedStudentDetails;
